import { getToken } from "services/auth/tokenAuth";
import doRequest from "services/helpers";
import { wait } from "utils/others";
import { getUserId } from "services/storage/general";

//#region Helpers
const parseToUserObject = obj => {
    if (!obj)
        return null;
    const {
        codigoUsuario,
        nombres,
        apellidos,
        categoria,
        rol,
        fechaCreacion
    } = obj;
    return {
        user: codigoUsuario,
        name: nombres,
        surname: apellidos,
        category: {
            id: categoria.idCategoria,
            name: categoria.nombre
        },
        role: {
            id: rol.idRol,
            name: rol.nombre
        },
        creationDate: fechaCreacion
    };
}
const parseToUserChanges = obj => {
    if (!obj)
        return null;
    const {
        nombres, apellidos,
        categoria, rol
    } = obj;
    return {
        name: nombres,
        surname: apellidos,
        category: categoria,
        role: rol
    };
}
//#endregion
export const requestGetUsers = async ({
    nameSurnameOrUser,
    categoryId,
    roleId,
    creationDate,
    page = 1
}) => {
    const [result, err] = await doRequest(
        "/Usuario/ObtenerListaUsuarios", "POST",
        {
            codigoUsuario: getUserId(),
            nombres: nameSurnameOrUser,
            idCategoria: categoryId,
            idRol: roleId,
            fechaCreacion: creationDate,
            pagina: page
        }, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    const { cantidad, listUsuarios } = data.data;
    return {
        total: cantidad,
        users: listUsuarios.map(parseToUserObject)
    };
}
export const requestCreateUser = async ({
    user,
    name,
    surname,
    role,
    campusId
}) => {
    const body = {
        nombres: name,
        apellidos: surname,
        idRol: role.id,
        codigoUsuario: user,
        idCampus: campusId,
        usuarioAuditoria: getUserId()
    };
    // return {
    //     success: true,
    //     newUser: parseToUserObject({
    //         codigoUsuario: user,
    //         nombres: name,
    //         apellidos: surname,
    //         categoria: {
    //             idCategoria: category.id,
    //             nombre: category.name
    //         },
    //         rol: {
    //             idRol: role.id,
    //             nombre: role.name
    //         },
    //         fechaCreacion: "13/10/2022"
    //     }),
    //     changes: null,
    //     message: null
    // };
    const [result, err] = await doRequest(
        "/Usuario/Crear", "POST",
        body, getToken());
    if (err)
        return null;
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return null;
    const { exito, mensaje, registro } = data.data;
    return {
        success: exito,
        newUser: parseToUserObject(registro),
        changes: null,
        message: mensaje
    };
}
export const requestUpdateUser = async ({
    user,
    name,
    surname,
    // category,
    role,
    campusId
}) => {
    const body = {
        nombres: name,
        apellidos: surname,
        idRol: role.id,
        codigoUsuario: user,
        idCampus: campusId,
        usuarioAuditoria: getUserId()
    };
    // return {
    //     success: true,
    //     newUser: parseToUserObject({
    //         codigoUsuario: user,
    //         nombres: name,
    //         apellidos: surname,
    //         categoria: {
    //             idCategoria: category.id,
    //             nombre: category.name
    //         },
    //         rol: {
    //             idRol: role.id,
    //             nombre: role.name
    //         },
    //         fechaCreacion: "13/10/2022"
    //     }),
    //     changes: parseToUserChanges({
    //         nombres: false,
    //         apellidos: true,
    //         categoria: false,
    //         rol: false
    //     }),
    //     message: null
    // };
    const [result, err] = await doRequest(
        "/Usuario/Editar", "POST",
        body, getToken());
    if (err)
        return null;
    const { data } = result;
    if (![1, 0].includes(data?.state))
        return null;
    const { exito, mensaje, registro, cambios } = data.data;
    return {
        success: exito,
        newUser: parseToUserObject(registro),
        changes: parseToUserChanges(cambios),
        message: mensaje
    };
}
export const requestDeleteUser = async user => {
    const [result, err] = await doRequest(
        "/Usuario/Eliminar", "POST",
        {
            codigoUsuario: user,
            usuarioAuditoria: getUserId()
        }, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    const { exito } = data.data;
    return {
        success: exito
    };
}
export const requestGetChangeHistoryUser = async user => {
    const [result, err] = await doRequest(
        `/Usuario/Historial/${user}`, "GET",
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data.map(({
        usuario,
        nombres,
        apellidos,
        categoria,
        rol,
        fecha,
        hora,
        cambios
    }) => ({
        user: usuario,
        name: nombres,
        surname: apellidos,
        category: categoria,
        role: rol,
        date: fecha,
        time: hora,
        changes: parseToUserChanges(cambios)
    }));
}